import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';

const ResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email || '';

  const [data, setData] = useState({
    otp: '',
    newPassword: '',
    confirmPassword: ''
  });

  if (!email) {
    navigate('/forgot-password');
    return null;
  }

  const handleOnChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { otp, newPassword, confirmPassword } = data;

    if (newPassword !== confirmPassword) {
      return toast.error("Passwords don't match");
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_SERVER_DOMIN}/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, otp, newPassword }),
      });
      const result = await res.json();
      
      if (res.ok) {
        toast.success(result.message);
        navigate('/login');
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      toast.error('Failed to reset password.');
    }
  };

  return (
    <div className="p-4 flex justify-center items-center min-h-[70vh]">
      <div className="bg-white shadow-lg p-6 rounded w-full max-w-md">
        <h1 className="text-2xl font-bold mb-4 text-center">Reset Password</h1>
        <p className="text-center text-sm mb-4">Enter the OTP sent to {email}</p>
        
        <form onSubmit={handleSubmit} className="flex flex-col">
          <label className="font-semibold mb-1">OTP</label>
          <input
            type="text"
            name="otp"
            className="p-2 border rounded mb-4 tracking-widest text-center text-lg"
            value={data.otp}
            onChange={handleOnChange}
            required
          />

          <label className="font-semibold mb-1">New Password</label>
          <input
            type="password"
            name="newPassword"
            className="p-2 border rounded mb-4"
            value={data.newPassword}
            onChange={handleOnChange}
            required
            minLength={6}
          />

          <label className="font-semibold mb-1">Confirm New Password</label>
          <input
            type="password"
            name="confirmPassword"
            className="p-2 border rounded mb-4"
            value={data.confirmPassword}
            onChange={handleOnChange}
            required
          />

          <button type="submit" className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 rounded">
            Reset Password
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
